import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_status_seen_recipients'

function StatusSeenRecipientsI18n({
  classes,
  productName
}: {
  classes: ReturnType<typeof styles>
  productName?: string
}) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const backLink = (txt: React.ReactNode) => <span className={classes.blueText}>{txt}</span>
  return (
    <div className={classes.content} data-testid="content">
      {formatMessage('intro', { productName, backLink })}
    </div>
  )
}

function StatusSeenRecipients(props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <StatusSeenRecipientsI18n classes={classes} productName={props.productName} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      All unique recipients seen in the past day (24 hours) or the last 30 days by {props.productName}
      are listed in this page, one email address per line. Maximum listed per page is 50. Click the{' '}
      <span className={classes.blueText}>Back to Dashboard</span> link on the page to return to the <b>Dashboard</b>{' '}
      page.
    </div>
  )
}

export default StatusSeenRecipients
